import React from "react";
import { useOutletContext } from "react-router-dom";
import LegalHtmlPage from "../components/LegalHtmlPage";

export default function TermsPage() {
  const { text } = useOutletContext();
  return (
    <LegalHtmlPage title={text.Arabic15} htmlField="terms_and_conditions" />
  );
}
